// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React from 'react'
import './ExtendedIntersticial.scss'

export interface ExtendedIntersticialProps {
  icon: JSX.Element
  title: string
  subtitle: string
  body: JSX.Element
  bottomAction?: {
    label: string
    redirectTo: string
    openInNewTab: boolean
    variant: string
    customClass?: string
  }
  customClass: string
}

const ExtendedIntersticial: React.FC<ExtendedIntersticialProps> = ({
  icon,
  title,
  subtitle,
  body,
  bottomAction,
  customClass
}): JSX.Element => {
  return (
    <div className={`extended-intersticial-container p-s8 p-sm-s10 gap-s4 ${customClass ?? ''}`}>
      <div className="internal-container p-s10 gap-s6">
        <div className="extended-intersticial-heading-container gap-s7">
          <div className="d-flex align-items-center align-self-strech gap-s7 h2 text-reset">
            {icon}
            <h2 className="h2">{title}</h2>
          </div>
          <span className="fw-medium">{subtitle}</span>
        </div>
        <div className="d-flex flex-column align-self-stretch align-items-flex-start gap-s3">{body}</div>
        {bottomAction && (
          <div className="align-self-start">
            <a
              className={
                bottomAction?.variant === 'link'
                  ? `link ${bottomAction?.customClass ?? ''}`
                  : `btn btn-${bottomAction?.variant ?? 'outline-primary'} ${bottomAction?.customClass ?? ''}`
              }
              href={bottomAction?.redirectTo}
              target={bottomAction?.openInNewTab ? '_blank' : '_self'}
              rel={bottomAction?.openInNewTab ? 'noreferrer' : undefined}
              intc-id={`${bottomAction?.variant}-${bottomAction?.label}-${title}`.replaceAll(' ', '-')}
              data-wap_ref={`${bottomAction?.variant}-${bottomAction?.label}-${title}`.replaceAll(' ', '-')}
              role={bottomAction?.variant}
              aria-label={`Go to ${bottomAction?.redirectTo}`}
            >
              {bottomAction?.label}
            </a>
          </div>
        )}
      </div>
    </div>
  )
}

export default ExtendedIntersticial
